const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
}

// Text a user typed (a campaign name, say), made safe to put in markup. vue-notification renders a
// toast's title and text as HTML, so a name like "Auto & Home <Leads>" otherwise loses "<Leads>",
// and one that is a tag runs it
export default function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, character => HTML_ESCAPES[character])
}
